import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";

/**
 * Fields type definition for content type 'TypeSmallLinkCta'
 * @name TypeSmallLinkCtaFields
 * @type {TypeSmallLinkCtaFields}
 * @memberof TypeSmallLinkCta
 */
export interface TypeSmallLinkCtaFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'text' (Text)
     * @name Text
     * @localized false
     */
    text: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'url' (URL)
     * @name URL
     * @localized false
     */
    url: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'type' (Type)
     * @name Type
     * @localized false
     */
    type: EntryFieldTypes.Symbol<"Link">;
    /**
     * Field type definition for field 'size' (Size)
     * @name Size
     * @localized false
     */
    size: EntryFieldTypes.Symbol<"Small">;
}

/**
 * Entry skeleton type definition for content type 'smallLinkCta' (Small Link CTA)
 * @name TypeSmallLinkCtaSkeleton
 * @type {TypeSmallLinkCtaSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-26T23:43:40.912Z
 * @version 5
 */
export type TypeSmallLinkCtaSkeleton = EntrySkeletonType<TypeSmallLinkCtaFields, "smallLinkCta">;
/**
 * Entry type definition for content type 'smallLinkCta' (Small Link CTA)
 * @name TypeSmallLinkCta
 * @type {TypeSmallLinkCta}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-26T23:43:40.912Z
 * @version 5
 */
export type TypeSmallLinkCta<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeSmallLinkCtaSkeleton, Modifiers, Locales>;

export function isTypeSmallLinkCta<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeSmallLinkCta<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'smallLinkCta'
}
